export enum ItemStatus {
    Pending = 1,
    Synced = 2,
    Cancelled = 4,
    ErrorProcessing = 5
  }

  export const ItemStatusText: Record<ItemStatus, string> = {
    [ItemStatus.Pending]: "Pending",
    [ItemStatus.Synced]: "Synced", 
    [ItemStatus.Cancelled]: "Cancelled",
    [ItemStatus.ErrorProcessing]: "Error Processing"
  };

  // TODO: Remove this enum and use InspectionPointTypeID instead. This is outdated.
export enum InspectionPointType {
  Unknown = 0,
  DropDownList = 1,
  YesNo = 2,
  Rating = 3,
  Text = 4,
  Date = 5,
  YesNoComment = 6,
  Verify = 7,
  Photo = 8,
  Note = 9,
  VideoOnly = 10
}

export const InspectionPointTypeText: Record<InspectionPointType, string> = {
  [InspectionPointType.Unknown]: "Unknown",
  [InspectionPointType.DropDownList]: "Drop Down List",
  [InspectionPointType.YesNo]: "Yes / No",
  [InspectionPointType.Rating]: "Rating",
  [InspectionPointType.Text]: "Text",
  [InspectionPointType.Date]: "Date",
  [InspectionPointType.YesNoComment]: "Yes / No Comment",
  [InspectionPointType.Verify]: "Verify",
  [InspectionPointType.Photo]: "Photo",
  [InspectionPointType.Note]: "Note",
  [InspectionPointType.VideoOnly]: "Video Only"
};

/**
 * Backend inspection point type_ID values (matches backend API)
 * NOTE: This differs from InspectionPointType enum above which is outdated
 */
export enum InspectionPointTypeID {
  Text = 1,
  YesNo = 4,
  Verify = 5,
  PhotoOnly = 6,
  VideoOnly = 7
}

export enum MediaType {
  Image = 1,
  Video = 2
}

export const MediaTypeText: Record<MediaType, string> = {
  [MediaType.Image]: "Image",
  [MediaType.Video]: "Video"
};